// src/components/layout/Header.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore.jsx';

function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
      <>
          {/*헤더 시작*/}
          <header className="header-nav">
              <div className="header-actions">
                  {/*<div className="search-box">*/}
                  {/*    <input type="text" placeholder="검색어를 입력하세요" />*/}
                  {/*        <i className="ri-search-line"></i>*/}
                  {/*</div>*/}
              </div>
          </header>
          {/*헤더 끝*/}
      </>
  );
}

export default Header;